import React from 'react';
import './GroupDraggableItem.scss';

export interface GroupDraggableItemProps {
  index: number;
  name: string;
  category: string;
  onRemove: () => void;
}

export const GroupDraggableItem: React.FC<GroupDraggableItemProps> = ({
  name,
  category,
  index,
  onRemove = () => {},
}): JSX.Element => (
  <div className="group-draggable-item">
    <div className="group-draggable-item__text">
      {category} / {name}
    </div>
    <div className="group-draggable-item__badge">Level {index + 1}</div>
    <button
      onClick={onRemove}
      type="button"
      className="group-draggable-item__remove"
    >
      &times;
    </button>
  </div>
);
